import { Close } from "@mui/icons-material";
import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    Grid,
    IconButton,
} from "@mui/material";
import { React, useState } from "react";
import Policy from "../Policy/Policy";

function AgreeInfo() {
    const [open, setOpen] = useState(false);
    const closeAgree = () => {
        setOpen(false);
    };

    const openAgree = () => {
        setOpen(true);
    };

    const copyModal = () => (
        <Grid container>
            <Dialog open={open} onClose={() => closeAgree()}>
                <DialogTitle id="id">
                    <Box display="flex" alignItems="center">
                        <Box flexGrow={1} />
                        <Box>
                            <IconButton onClick={() => closeAgree()}>
                                <Close />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <Grid item xs={12}>
                    <Policy />
                </Grid>
                <Grid item xs={12}>
                    <Box flexGrow={1} />
                    <Button
                        onClick={() => closeAgree()}
                        variant="contained"
                        style={{
                            backgroundColor: "#01314D",
                            margin: "20px",
                        }}
                    >
                        Close
                    </Button>
                </Grid>
            </Dialog>
        </Grid>
    );
    return (
        <Grid item xs={12} style={{ margin: "10px" }}>
            <div style={{ position: "absolute" }}>{copyModal()}</div>
            <Button
                onClick={() => openAgree()}
                variant="contained"
                style={{
                    backgroundColor: "#01314D",
                }}
            >
                View Terms and Conditions
            </Button>
        </Grid>
    );
}

export default AgreeInfo;
